import React from "react";
import joseNavas from "../images/jose-navas.jpg";

export default function HeroPhoto() {
  return (
    <div className="heroPhoto" aria-hidden="true">
      <img src={joseNavas} alt="Jose A. Navas" />
    </div>
  );
}
